(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hh-review-slider')) {
    class HHReviewSlider extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.viewport = this.querySelector('[data-review-viewport]');
        this.track = this.querySelector('.hh-reviews__track');
        this.cards = Array.from(this.querySelectorAll('.hh-reviews__card'));
        this.previousButton = this.querySelector('[data-review-previous]');
        this.nextButton = this.querySelector('[data-review-next]');
        this.currentIndex = 0;
        this.maximumIndex = 0;
        this.touchStartX = null;

        if (!this.viewport || !this.track || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));

        this.viewport.addEventListener('touchstart', (event) => {
          this.touchStartX = event.touches[0]?.clientX ?? null;
        }, { passive: true });

        this.viewport.addEventListener('touchend', (event) => {
          if (this.touchStartX === null) return;

          const touchEndX = event.changedTouches[0]?.clientX ?? this.touchStartX;
          const distance = this.touchStartX - touchEndX;
          this.touchStartX = null;

          if (Math.abs(distance) < 45) return;
          this.move(distance > 0 ? 1 : -1);
        }, { passive: true });

        this.addEventListener('shopify:block:select', (event) => {
          const selectedCard = event.target.closest('.hh-reviews__card');
          const selectedIndex = this.cards.indexOf(selectedCard);

          if (selectedIndex >= 0) {
            this.currentIndex = Math.min(selectedIndex, this.maximumIndex);
            this.render();
          }
        });

        this.resizeObserver = new ResizeObserver(() => this.refresh());
        this.resizeObserver.observe(this.viewport);

        requestAnimationFrame(() => this.refresh());
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      getMeasurements() {
        const card = this.cards[0];
        if (!card) return { step: this.viewport.clientWidth, visibleCards: 1, maximumOffset: 0 };

        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const cardWidth = card.getBoundingClientRect().width;
        const step = cardWidth + gap;
        const visibleCards = Math.max(1, Math.floor((this.viewport.clientWidth + gap) / step));
        const trackWidth = this.track.getBoundingClientRect().width;
        const maximumOffset = Math.max(0, trackWidth - this.viewport.clientWidth);

        return { step, visibleCards, maximumOffset };
      }

      move(direction) {
        this.currentIndex = Math.min(
          this.maximumIndex,
          Math.max(0, this.currentIndex + direction)
        );
        this.render();
      }

      refresh() {
        const { visibleCards } = this.getMeasurements();
        this.maximumIndex = Math.max(0, this.cards.length - visibleCards);
        this.currentIndex = Math.min(this.currentIndex, this.maximumIndex);
        this.render();
      }

      render() {
        const { step, maximumOffset } = this.getMeasurements();
        const offset = Math.min(this.currentIndex * step, maximumOffset);

        this.track.style.transform = `translate3d(${-offset}px, 0, 0)`;

        this.previousButton.disabled = this.currentIndex === 0;
        this.nextButton.disabled = this.currentIndex >= this.maximumIndex;
      }
    }

    customElements.define('hh-review-slider', HHReviewSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
